import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Map } from 'immutable';
import { commaFormatNumber, formatNumberWithPostfix, replaceCitations, capitalize } from '@Utils/String';
import { recordCountOrTotalResultFromBreadcrumb } from '@Containers/PatentFamilyClustering/selectors';
import BreadcrumbTooltipContainer from '../BreadcrumbTooltip';

export default class Breadcrumb extends React.PureComponent {
  getBreadcrumbContent() {
    const { breadcrumb } = this.props;

    if (breadcrumb.get('isHistoryBreadcrumb')) {
      return 'From history';
    }

    if (breadcrumb.get('batchSearch')) {
      return 'Batch Load';
    }

    const totalResults = recordCountOrTotalResultFromBreadcrumb(breadcrumb) || 0;

    return formatNumberWithPostfix(totalResults, true, 2);
  }

  getBreadcrumbAriaLabel() {
    const { breadcrumb } = this.props;
    const context = breadcrumb && breadcrumb.get('context');
    return `Breadcrumb link to ${this.getBreadcrumbContent()} ${context}`;
  }

  getCrumbLinkClassNames() {
    const { breadcrumb } = this.props;
    if (breadcrumb.get('databaseId') === '20') return classnames(['commercialsubstances', 'e2e-breadcrumb']);
    return classnames([breadcrumb.get('context'), 'e2e-breadcrumb']);
  }

  getTooltipHeader() {
    const { breadcrumb } = this.props;
    const totalResults = recordCountOrTotalResultFromBreadcrumb(breadcrumb);

    return breadcrumb.get('batchSearch')
      ? 'Batch Loaded'
      : `${commaFormatNumber(totalResults)} ${capitalize(replaceCitations(breadcrumb.get('context', '')))}`;
  }

  goToResult = () => {
    const { breadcrumb, goToResultPage } = this.props;
    goToResultPage(breadcrumb.toJS());
  };

  render() {
    const { index, breadcrumb } = this.props;
    const tooltipId = breadcrumb.get('id');

    return (
      <li
        className={classnames('new-breadcrumbs__item', {
          'new-breadcrumbs__item--active': breadcrumb.get('active'),
        })}>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/role-supports-aria-props */}
        <a
          role="button"
          aria-level={index + 1}
          aria-label={this.getBreadcrumbAriaLabel()}
          onClick={this.goToResult}
          className={classnames(this.getCrumbLinkClassNames(), 'new-breadcrumbs__link')}
          aria-controls="resultsPage"
          tabIndex="0"
          data-tip
          data-for={tooltipId}>
          <span className="new-breadcrumbs__link-content new-breadcrumbs__clip-content">{this.getBreadcrumbContent()}</span>
        </a>
        <BreadcrumbTooltipContainer id={tooltipId} breadcrumb={breadcrumb} header={this.getTooltipHeader()} />
      </li>
    );
  }
}

Breadcrumb.propTypes = {
  index: PropTypes.number,
  breadcrumb: PropTypes.instanceOf(Map).isRequired,
  goToResultPage: PropTypes.func.isRequired,
};
